import React from "react";
import { GoArrowLeft } from "react-icons/go";
import { Link } from "react-router-dom";

const PrescriptionDetails = () => {
  const detailstyles = `
  /* PrescriptionDetails.css */

  p { 
  font-size : 0.875em;
}

.container {
  max-width: 1200px;
}

.card {
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.02);
}

.fw-bold {
  font-weight: 700;
}

.fw-medium {
  font-weight: 500;
}

.fw-semibold {
  font-weight: 600;
}

.badge.bg-success {
  background-color: #28a745;
}

.btn-dark {
  background-color: #000;
  color: #fff;
}

.btn-outline-secondary {
  border-color: #ccc;
  color: #333;
}

.btn-outline-secondary:hover {
  background-color: #eee;
}

.btn-danger {
  background-color: #dc3545;
  border: none;
}

.medication-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  background: #f9f9f9;
  margin-top: 0.5rem;
}

@media (max-width: 768px) {
  .d-flex {
    flex-direction: column !important;
  }

  .d-grid {
    grid-template-columns: 1fr !important;
  }
}
`;

const medications = [
  {
    medication: "Lisinopril",
    dosage: "10mg",
    frequency: "Once daily",
    duration: "3 months",
    notes: "Take with food",
  },
  {
    medication: "Metformin",
    dosage: "500mg",
    frequency: "Twice daily",
    duration: "3 months",
    notes: "Take after meals",
  },
];


  return (
    <>
      <style>{detailstyles}</style>
      <div className="prescription-container">
        <div className="flex items-center gap-4 flex-wrap">
          <Link to="/Clinicprescription">
            <button className="bg-[#fff] inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground size-10">
              <GoArrowLeft />
              <span className="sr-only">Back</span>
            </button>
          </Link>
          <div>
            <h1 className="text-2xl lg:text-3xl font-bold tracking-tight mb-2">
              Prescription Details
            </h1>
            <p className="text-muted-foreground">
              View patient Prescription Details.
            </p>
          </div>
        </div>
        <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex justify-content-between"
          ></div>
      </div>

      <div className="main-content row">
        {/* Left Column */}
        <div className="col-md-8">
          <div className="card mb-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h5 className="fw-bold mb-1">Prescription Information</h5>
                  <p className="text-muted small mb-0">
                    Details about this prescription
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Prescription ID</strong>
                    <br />1
                  </p>
                  <p>
                    <strong>Issue Date</strong>
                    <br />
                    2023-07-15
                  </p>
                  <p>
                    <strong>Diagnosis</strong>
                    <br />
                    Fever And Cough.
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Prescribed By</strong>
                    <br />
                    Dr. venu
                  </p>
                  <p>
                    <strong>Expiry Date</strong>
                    <br />
                    2023-10-15
                  </p>
                  <p>
                    <strong>Refills Remaining</strong>
                    <br />2
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h5 className="fw-bold mb-3">Medications</h5>
              <div className="row">
  {medications.map((item, index) => (
    <div className="col-md-6" key={index}>
      <div className="medication-box">
        <p>
          <strong>Medication:</strong> {item.medication}
        </p>
        <p>
          <strong>Dosage:</strong> {item.dosage}
        </p>
        <p>
          <strong>Frequency:</strong> {item.frequency}
        </p>
        <p>
          <strong>Duration:</strong> {item.duration}
        </p>
        <p>
          <strong>Notes:</strong> {item.notes}
        </p>
      </div>
    </div>
  ))}
</div>

            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h5 className="fw-bold mb-3">Tests</h5>
              <div className="row">
  {medications.map((item, index) => (
    <div className="col-md-6" key={index}>
      <div className="medication-box">
        <p>
          <strong>Medication:</strong> {item.medication}
        </p>
        <p>
          <strong>Dosage:</strong> {item.dosage}
        </p>
        <p>
          <strong>Frequency:</strong> {item.frequency}
        </p>
        <p>
          <strong>Duration:</strong> {item.duration}
        </p>
        <p>
          <strong>Notes:</strong> {item.notes}
        </p>
      </div>
    </div>
  ))}
</div>
              <p className="mt-3">
                Patient responding well to current medication regimen. Blood
                pressure has stabilized.
              </p>
              
            </div>
          </div>

          <div className="card mb-5">
            <div className="card-body">
              <h5 className="fw-bold mb-2">Refill History</h5>
              <p className="text-muted mb-1">History of prescription refills</p>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="fw-bold mb-3">Patient Information</h5>
              <div className="d-flex flex-row align-items-center mt-2 gap-3">
                <img
                  src="https://images.unsplash.com/photo-1526779259212-939e64788e3c?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8ZnJlZSUyMGltYWdlc3xlbnwwfHwwfHx8MA%3D%3D"
                  alt="Patient"
                  className="rounded-circle mb-2"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />

                <div className="d-flex align-items-start flex-column">
                  <p className="fw-semibold mb-1">Ananya</p>
                  <p className="text-muted small mb-1">ID: PT10045</p>
                  <p className="text-muted small">DOB: 1985-04-12</p>
                  <p className="text-muted small">Status: Completed</p>
                </div>
              </div>
              <button className="gradient-dark-button w-100 mt-3">
                View Patient Profile
              </button>
            </div>
          </div>

          {/* <div className="card">
            <div className="card-body">
              <h5 className="fw-bold mb-3">Actions</h5>
              <button className="btn btn-dark w-100 mb-2">
                Renew Prescription
              </button>
              <button className="btn btn-outline-secondary w-100 mb-2">
                Edit Prescription
              </button>
              <button className="btn btn-outline-secondary w-100 mb-2">
                Print Prescription
              </button>
              <button className="btn btn-danger w-100">
                Cancel Prescription
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default PrescriptionDetails;
